/**
 * A small, bounded set of object URLs, by key — for the photo viewer, which
 * holds the stored files it has drawn (#665 follow-up).
 *
 * `held` maps a key to an object URL, or to null for "known not drawable",
 * which costs nothing to keep. Adding a key makes it the newest. Past `max`
 * drawable entries, the oldest are revoked and dropped, so memory stays
 * bounded however many photos someone steps through. Key order is insertion
 * order (the keys are links, never integer-like strings), which makes it the
 * age.
 */
export function holdNewest(
  held: Record<string, string | null>,
  key: string,
  url: string | null,
  max: number,
  revoke: (url: string) => void = (u) => URL.revokeObjectURL(u),
): Record<string, string | null> {
  const next = { ...held };
  const previous = next[key];
  delete next[key];
  next[key] = url;
  // Replacing a key's own URL frees the one it replaced.
  if (previous && previous !== url) revoke(previous);
  const drawable = Object.keys(next).filter((k) => next[k]);
  for (const k of drawable.slice(0, Math.max(0, drawable.length - max))) {
    revoke(next[k]!);
    delete next[k];
  }
  return next;
}
